import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import {
  getAllVaccines,
  removeVaccines,
  restoreVaccines
} from '../../../redux/actions/vaccines';
import Datatable from '../../../components/Datatable';
import TableHeader from '../../../components/TableHeader';
import ModalRemoveItem from '../../../components/ModalRemoveItem';
import ModalRestoreItem from '../../../components/ModalRestoreItem';
import PageAddVaccine from './Add';
import PageEditVaccine from './Edit';

const ModalAddVaccine = props => {
  const { handleModalClose, showModal, data } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageAddVaccine
            handleModalClose={handleModalClose}
            data={data || {}}
          />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalAddVaccine.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  data: PropTypes.object
};

const ModalEditVaccine = props => {
  const { handleModalClose, showModal, match } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageEditVaccine
            handleModalClose={handleModalClose}
            match={match || { params: { id: '' } }}
          />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalEditVaccine.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  match: PropTypes.object
};

function List (props) {
  const { pet } = props;
  const vaccines = useSelector(state => state.vaccines);
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const tableData = vaccines.data.filter(item => {
    return pet && item.pet._id === pet._id;
  });
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeVaccines(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreVaccines({ _id: id, active: true }));
  };
  const [showModalEditVaccine, setShowModalEditVaccine] = useState(false);
  const [dataItemEditVaccine, setDataItemWillEditVaccine] = useState({});
  const [showModalAddVaccine, setShowModalAddVaccine] = useState(false);

  useEffect(() => {
    if (pet._id) {
      dispatch(getAllVaccines({ company, pet: pet._id }));
    }
  }, [dispatch, pet._id, company]);

  const columns = [
    {
      title: 'Nome',
      data: 'product.name',
      render: data => data || '---'
    },
    {
      title: `N${String.fromCharCode(176)} de Partida`,
      data: 'identifier',
      render: data => data || '---'
    },
    {
      title: 'Aplicação',
      data: 'vaccinationDate',
      render: (data, type) => {
        if (data) {
          if (type === 'display') {
            return new Date(data).toLocaleString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Próxima Aplicação',
      data: 'vaccinationNextDate',
      render: (data, type) => {
        if (data) {
          if (type === 'display') {
            return new Date(data).toLocaleDateString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Veterinário',
      data: 'veterinarian.name',
      render: data => data || '---'
    },
    {
      title: 'PET',
      data: 'pet.name',
      render: data => data || '---'
    },
    {
      title: 'Fabricação',
      data: 'manufacturingDate',
      render: (data, type) => {
        if (data) {
          if (type === 'display') {
            return new Date(data).toLocaleDateString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Vencimento',
      data: 'expirationDate',
      render: (data, type) => {
        if (data) {
          if (type === 'display') {
            return new Date(data).toLocaleDateString() || '---';
          } else {
            return new Date(data);
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Descrição',
      data: 'description',
      render: data => data || '---'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
            <button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>
            ${
              !obj.active
                ? ''
                : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
            }
            ${
              obj.active
                ? ''
                : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
            }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const match = {
      params: {
        id
      }
    };
    setDataItemWillEditVaccine(match);
    setShowModalEditVaccine(true);
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(new Date(dataRow.vaccinationDate).toLocaleString());
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(new Date(dataRow.vaccinationDate).toLocaleString());
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  return (
    <div>
      <div className="mb-1">
        <button
          type="button"
          className="btn btn-success"
          disabled={showModalAddVaccine}
          onClick={() => setShowModalAddVaccine(true)}
        >
          <i className="fa fa-plus" />
          &nbsp;Vacina
        </button>
      </div>
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir a vacina aplicada'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar a vacina aplicada'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <ModalEditVaccine
        showModal={showModalEditVaccine}
        handleModalClose={() => setShowModalEditVaccine(false)}
        match={dataItemEditVaccine}
      />
      <ModalAddVaccine
        showModal={showModalAddVaccine}
        handleModalClose={() => setShowModalAddVaccine(false)}
        data={{ pet: pet ? pet._id : '' }}
      />
      <TableHeader
        title={'Vacinas'}
        url={'/vaccines/add'}
        updateList={() => dispatch(getAllVaccines({ company, pet: pet._id }))}
        isFetching={vaccines.isFetching}
        hideAddButton={!!pet}
      />
      <Datatable
        data={tableData}
        columns={columns}
        buttons={buttons}
        order={[2, 'asc']}
        handleUpdateButton={handleUpdateButton}
        handleDeleteButton={handleDeleteButton}
        handleRestoreButton={handleRestoreButton}
      />
    </div>
  );
}

List.propTypes = {
  pet: PropTypes.object
};

export default List;
